export const STATUS_META = {
  field_visit: { label: "Field Visit", color: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  waiting_office: { label: "Waiting for Office", color: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  office_review: { label: "Office Review", color: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  scope_preparing: { label: "Scope Preparing", color: "bg-violet-500/15 text-violet-300 border-violet-500/30" },
  estimating: { label: "Estimating", color: "bg-violet-500/15 text-violet-300 border-violet-500/30" },
  price_ready: { label: "Price Ready", color: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  estimate_presented: { label: "Estimate Presented", color: "bg-teal-500/15 text-teal-300 border-teal-500/30" },
  sold: { label: "Sold", color: "bg-emerald-500/20 text-emerald-300 border-emerald-500/40" },
  follow_up: { label: "Follow-Up", color: "bg-orange-500/15 text-orange-300 border-orange-500/30" },
  lost: { label: "Lost", color: "bg-rose-500/15 text-rose-300 border-rose-500/30" },
  active_project: { label: "Active Project", color: "bg-blue-500/15 text-blue-300 border-blue-500/30" },
  completed: { label: "Completed", color: "bg-slate-500/15 text-slate-300 border-slate-500/30" },
};

export function statusMeta(s) {
  return STATUS_META[s] || { label: s, color: "bg-slate-500/15 text-slate-300 border-slate-500/30" };
}
